import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  de: {
    nav: {
      about: 'Über uns',
      team: 'Team',
      services: 'Leistungen',
      whyus: 'Warum wir',
      growth: 'Projekte',
      contact: 'Kontakt',
      apply: 'Jetzt bewerben',
    },
    hero: {
      eyebrow: 'Personal- & Auftragsvermittlung · Freiburg im Breisgau',
      title1: 'Ihr zuverlässiger Partner',
      title2: 'für Personal- &',
      title3: 'Auftragsvermittlung',
      subtitle: 'De Melo Recruiting verbindet Unternehmen, Fachkräfte und Subunternehmer effizient und zuverlässig.',
      cta1: 'Personal anfragen',
      cta2: 'Aufträge erhalten',
      cta3: 'Jetzt bewerben',
      ceoLabel: 'Geschäftsführung',
      ceoName: 'Thiago Pereira Casanova DeMelo',
      ceoRole: 'Geschäftsführer',
      scroll: 'Scroll',
    },
    about: {
      eyebrow: 'Über uns',
      title: 'Vermittlung mit Substanz – aus Freiburg, für ganz Europa.',
      p1: 'De Melo Recruiting ist seit fast zwei Jahren erfolgreich in der Personal- und Auftragsvermittlung tätig. Unter der Leitung von Geschäftsführer Thiago Pereira Casanova DeMelo vermitteln wir Unternehmen schnell und zuverlässig passendes Personal sowie qualifizierte Subunternehmer aus unserem bestehenden Netzwerk.',
      p2: 'Besonders im Baugewerbe vermitteln wir Personal sowie Subunternehmer in sämtlichen Bereichen und unterstützen Unternehmen bei der erfolgreichen Umsetzung ihrer Projekte.',
      p3: 'Zusätzlich bieten wir auch Personallösungen für Unternehmen außerhalb der Baubranche an – unter anderem im Bereich Logistik, Produktion und allgemeine Helfertätigkeiten.',
      p4: 'Unser besonderer Vorteil: ein gewachsenes Netzwerk aus **über 1.000+ Firmen** – Subunternehmer und Fachkräfte aus Osteuropa und der gesamten EU. Wir bringen für Sie zuverlässige Teams nach Deutschland, schnell, geprüft und einsatzbereit.',
      stats: [
        { value: '100%', label: 'Persönliche Betreuung' },
        { value: '~2', label: 'Jahre am Markt' },
        { value: '24h', label: 'Reaktionszeit' },
        { value: 'EU', label: 'Einsatzgebiet' },
      ],
    },
    team: {
      eyebrow: 'Unser Team',
      title: 'Erfahrung. Struktur. Verbindlichkeit.',
      members: [
        {
          name: 'Thiago Pereira Casanova de Melo',
          role: 'Geschäftsführer',
          initials: 'TM',
          photo: '/images/thiago.jpg',
          bio: 'Thiago Pereira Casanova de Melo leitet De Melo Recruiting mit dem Fokus auf nachhaltige Partnerschaften, professionelle Vermittlung und langfristige Zusammenarbeit. Sein Ziel: Unternehmen, Fachkräfte und Subunternehmen erfolgreich zusammenbringen.',
        },
        {
          name: 'Pascal Horst Weidler',
          role: 'Vertriebsleiter',
          initials: 'PW',
          photo: '/images/pascal.jpg',
          bio: 'Pascal Horst Weidler verantwortet den Vertrieb bei De Melo Recruiting und ist zentraler Ansprechpartner für Unternehmen, die Personal oder Subunternehmer benötigen. Sein Fokus: belastbare Kundenbeziehungen und passgenaue Angebote.',
        },
        {
          name: 'Tony Krannich',
          role: 'Projektmanager',
          initials: 'TK',
          photo: '/images/tony.jpg',
          bio: 'Tony Krannich begleitet Projekte und Vermittlungsprozesse operativ und sorgt für strukturierte Koordination zwischen Unternehmen, Mitarbeitern und Subunternehmern. Schwerpunkt: Projektorganisation, Kommunikation und Umsetzung.',
        },
        {
          name: 'Michal Lysakowski',
          role: 'Projektmanager',
          initials: 'ML',
          photo: '/images/michal.jpg',
          bio: 'Michal Lysakowski koordiniert Einsätze und Teams direkt vor Ort und sichert die reibungslose Umsetzung von Projekten. Durch seine mehrsprachige Kommunikation ist er die Brücke zwischen deutschen Auftraggebern und unseren Partnern aus der EU.',
        },
      ],
    },
    services: {
      eyebrow: 'Leistungen',
      title: 'Maßgeschneiderte Lösungen – für Bau und Industrie.',
      construction: {
        title: 'Baugewerbe',
        subtitle: 'Unser Kernbereich',
        items: [
          'Vermittlung von Subunternehmern im Bau',
          'Vermittlung von Bauaufträgen für Subunternehmer',
          'Personalvermittlung im Baugewerbe',
          'Unterstützung in sämtlichen Baubereichen',
        ],
      },
      other: {
        title: 'Weitere Branchen',
        subtitle: 'Flexible Personallösungen',
        items: [
          'Produktionshelfer',
          'Logistikhelfer',
          'Allgemeine Helfertätigkeiten',
          'Personal für Industrie & Produktion',
          'Flexible Personallösungen für Unternehmen',
        ],
      },
    },
    whyus: {
      eyebrow: 'Warum De Melo Recruiting',
      title: 'Sechs Gründe, uns zu vertrauen.',
      items: [
        { t: 'Schnelle Vermittlung', d: 'Kurze Reaktionszeiten und zügige Besetzung.' },
        { t: 'Großes EU-weites Netzwerk', d: 'Pool aus über 1.000+ Unternehmen – geprüfte Subunternehmer und Fachkräfte aus Osteuropa und der gesamten EU.' },
        { t: 'Persönliche Betreuung', d: 'Ein Ansprechpartner – durchgehend und verbindlich.' },
        { t: 'Zuverlässige Zusammenarbeit', d: 'Transparente Prozesse und klare Kommunikation.' },
        { t: 'Flexible Lösungen', d: 'Für Unternehmen, Subunternehmer und Bewerber.' },
        { t: 'Langfristige Partnerschaften', d: 'Wir denken in Beziehungen – nicht in Tickets.' },
      ],
    },
    growth: {
      eyebrow: 'Projekte & Wachstum',
      title: 'Wir wachsen – mit unseren Partnern in ganz Europa.',
      body: 'De Melo Recruiting entwickelt sich stetig weiter und arbeitet mit einem starken Netzwerk an Subunternehmern und Fachkräften aus Osteuropa und der gesamten EU. So bringen wir zuverlässige Teams kurzfristig in deutsche Projekte.',
      tags: ['Bauprojekte', 'Industrie', 'Logistik', 'Produktion', 'Subunternehmer', 'EU-weites Netzwerk', 'Osteuropa'],
      marquee: ['Starkes Netzwerk', 'Logistik-Partner', 'Industrie', 'Produktion', 'Bauprojekte', 'Subunternehmer-Teams'],
    },
    contact: {
      eyebrow: 'Kontakt',
      title: 'Sprechen wir.',
      sub: 'Ob Personalanfrage, neuer Auftrag oder Bewerbung – wir freuen uns auf Ihre Nachricht.',
      formTitle: 'Nachricht senden',
      form: {
        type: 'Anfrageart',
        types: { personnel: 'Personal anfragen', orders: 'Auftrag anfragen', general: 'Allgemein' },
        name: 'Name', company: 'Firma (optional)', phone: 'Telefon (optional)', email: 'E-Mail',
        subject: 'Betreff (optional)',
        message: 'Ihre Nachricht',
        submit: 'Nachricht senden',
        sending: 'Wird gesendet…',
        success: 'Vielen Dank! Wir melden uns kurzfristig.',
        error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
      },
      info: {
        phone: 'Telefon', email: 'E-Mail', location: 'Standort',
        locationVal: 'Buchenstraße 14, 79108 Freiburg im Breisgau',
      },
    },
    apply: {
      title: 'Jetzt bewerben',
      sub: 'Senden Sie uns Ihre Bewerbung – mit Lebenslauf als PDF.',
      name: 'Name', email: 'E-Mail', phone: 'Telefon', position: 'Position / Bereich', message: 'Anschreiben (optional)',
      resume: 'Lebenslauf (PDF, max. 8 MB)',
      submit: 'Bewerbung senden',
      sending: 'Wird gesendet…',
      success: 'Vielen Dank! Wir melden uns in Kürze.',
      error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    },
    footer: {
      tagline: 'Personalvermittlung • Auftragsvermittlung • Subunternehmervermittlung',
      rights: 'Alle Rechte vorbehalten.',
      social: 'Social Media',
      quick: 'Navigation',
      legal: 'Rechtliches', imprint: 'Impressum', privacy: 'Datenschutz',
    },
    legal: {
      back: 'Zurück zur Startseite',
      imprintEyebrow: 'Rechtliche Angaben',
      privacyEyebrow: 'DSGVO / Datenschutz',
    },
    cookie: {
      eyebrow: 'Cookie-Hinweis',
      title: 'Wir respektieren Ihre Privatsphäre.',
      body: 'Wir verwenden ausschließlich technisch notwendige Cookies für den Betrieb dieser Website (z. B. zum Speichern Ihrer Sprachwahl). Optionale Cookies, z. B. für Statistiken, setzen wir nur mit Ihrer Einwilligung. Mehr Informationen finden Sie in unserer',
      privacyLink: 'Datenschutzerklärung',
      accept: 'Alle akzeptieren',
      necessary: 'Nur notwendige',
    },
    whatsapp: {
      tooltip: 'Chat starten',
      status: 'Antwortet meist innerhalb von 24h',
      greeting: 'Hallo 👋 — schreiben Sie uns direkt per WhatsApp. Wählen Sie ein Anliegen, oder formulieren Sie Ihre Nachricht frei.',
      choose: 'Schnellauswahl',
      preset1: 'Personal anfragen',
      preset2: 'Aufträge / Subunternehmer',
      preset3: 'Bewerbung',
      openChat: 'WhatsApp-Chat starten',
      fallback: 'Hallo De Melo Recruiting, ich habe eine Anfrage.',
    },
    call: {
      tooltip: 'Jetzt anrufen',
    },
  },
  en: {
    nav: {
      about: 'About', team: 'Team', services: 'Services', whyus: 'Why us',
      growth: 'Projects', contact: 'Contact', apply: 'Apply now',
    },
    hero: {
      eyebrow: 'Staffing & project placement · Freiburg im Breisgau',
      title1: 'Your reliable partner',
      title2: 'for staffing &',
      title3: 'project placement',
      subtitle: 'De Melo Recruiting connects companies, specialists and subcontractors – efficiently and reliably.',
      cta1: 'Request talent', cta2: 'Get projects', cta3: 'Apply now',
      ceoLabel: 'Management',
      ceoName: 'Thiago Pereira Casanova DeMelo',
      ceoRole: 'Managing Director',
      scroll: 'Scroll',
    },
    about: {
      eyebrow: 'About us',
      title: 'Recruiting with substance – from Freiburg, for all of Europe.',
      p1: 'De Melo Recruiting has been successfully active in staffing and project placement for nearly two years. Under managing director Thiago Pereira Casanova DeMelo, we provide companies with the right personnel and qualified subcontractors – fast and reliably, directly from our established network.',
      p2: 'Our particular focus is the construction industry, where we place both personnel and subcontractors across all trades, supporting companies in executing their projects.',
      p3: 'In addition, we offer staffing solutions for companies outside construction – including logistics, manufacturing and general helper roles.',
      p4: 'Our particular strength: an established network of **1,000+ companies** – subcontractors and specialists from Eastern Europe and across the entire EU. We bring reliable, vetted and ready-to-deploy teams to Germany, fast and on demand.',
      stats: [
        { value: '100%', label: 'Personal support' },
        { value: '~2', label: 'Years in market' },
        { value: '24h', label: 'Response time' },
        { value: 'EU', label: 'Operating area' },
      ],
    },
    team: {
      eyebrow: 'Our team',
      title: 'Experience. Structure. Commitment.',
      members: [
        { name: 'Thiago Pereira Casanova de Melo', role: 'Managing Director', initials: 'TM',
          photo: '/images/thiago.jpg',
          bio: 'Thiago leads De Melo Recruiting with a focus on sustainable partnerships, professional placement and long-term collaboration – successfully bringing companies, specialists and subcontractors together.' },
        { name: 'Pascal Horst Weidler', role: 'Head of Sales', initials: 'PW',
          photo: '/images/pascal.jpg',
          bio: 'Pascal Horst Weidler leads sales at De Melo Recruiting and is the central contact for companies looking for staff or subcontractors. His focus: strong client relationships and tailored offers.' },
        { name: 'Tony Krannich', role: 'Project Manager', initials: 'TK',
          photo: '/images/tony.jpg',
          bio: 'Tony manages projects and placement processes operationally, ensuring structured coordination between companies, workers and subcontractors. Focus: project organisation, communication, execution.' },
        { name: 'Michal Lysakowski', role: 'Project Manager', initials: 'ML',
          photo: '/images/michal.jpg',
          bio: 'Michal Lysakowski coordinates deployments and teams directly on-site, ensuring smooth project execution. His multilingual communication bridges German clients with our EU-wide partners.' },
      ],
    },
    services: {
      eyebrow: 'Services',
      title: 'Tailored solutions – for construction and industry.',
      construction: { title: 'Construction', subtitle: 'Our core area',
        items: ['Subcontractor placement in construction','Construction project placement for subcontractors','Construction staffing','Support across all trades'] },
      other: { title: 'Further industries', subtitle: 'Flexible staffing solutions',
        items: ['Production helpers','Logistics helpers','General helper roles','Industrial & manufacturing staff','Flexible staffing for companies'] },
    },
    whyus: {
      eyebrow: 'Why De Melo Recruiting',
      title: 'Six reasons to trust us.',
      items: [
        { t: 'Fast placement', d: 'Short response times and quick staffing.' },
        { t: 'Large EU-wide network', d: 'A pool of 1,000+ companies – vetted subcontractors and specialists from Eastern Europe and across the entire EU.' },
        { t: 'Personal support', d: 'One dedicated contact – consistent and committed.' },
        { t: 'Reliable collaboration', d: 'Transparent processes and clear communication.' },
        { t: 'Flexible solutions', d: 'For companies, subcontractors and applicants.' },
        { t: 'Long-term partnerships', d: 'We think in relationships – not tickets.' },
      ],
    },
    growth: {
      eyebrow: 'Projects & growth',
      title: 'We grow – with our partners across Europe.',
      body: 'De Melo Recruiting continuously expands together with a strong network of subcontractors and specialists from Eastern Europe and across the entire EU – bringing reliable teams to German projects on short notice.',
      tags: ['Construction', 'Industry', 'Logistics', 'Manufacturing', 'Subcontractors', 'EU-wide network', 'Eastern Europe'],
      marquee: ['Strong network', 'Logistics partners', 'Industry', 'Manufacturing', 'Construction', 'Subcontractor teams'],
    },
    contact: {
      eyebrow: 'Contact', title: 'Let\u2019s talk.',
      sub: 'Whether it\u2019s a staffing request, a new project or an application – we look forward to your message.',
      formTitle: 'Send a message',
      form: {
        type: 'Inquiry type',
        types: { personnel: 'Request talent', orders: 'Request projects', general: 'General' },
        name: 'Name', company: 'Company (optional)', phone: 'Phone (optional)', email: 'Email',
        subject: 'Subject (optional)',
        message: 'Your message',
        submit: 'Send message', sending: 'Sending…',
        success: 'Thank you! We will be in touch shortly.',
        error: 'Something went wrong. Please try again.',
      },
      info: { phone: 'Phone', email: 'Email', location: 'Location',
        locationVal: 'Buchenstraße 14, 79108 Freiburg im Breisgau' },
    },
    apply: {
      title: 'Apply now', sub: 'Send us your application – with CV as PDF.',
      name: 'Name', email: 'Email', phone: 'Phone', position: 'Position / Area', message: 'Cover letter (optional)',
      resume: 'CV (PDF, max. 8 MB)', submit: 'Send application', sending: 'Sending…',
      success: 'Thank you! We will be in touch shortly.',
      error: 'Something went wrong. Please try again.',
    },
    footer: {
      tagline: 'Staffing • Project placement • Subcontractor placement',
      rights: 'All rights reserved.', social: 'Social media', quick: 'Navigation',
      legal: 'Legal', imprint: 'Imprint', privacy: 'Privacy',
    },
    legal: {
      back: 'Back to home',
      imprintEyebrow: 'Legal notice',
      privacyEyebrow: 'GDPR / Privacy',
    },
    cookie: {
      eyebrow: 'Cookie notice',
      title: 'We respect your privacy.',
      body: 'We only use technically necessary cookies to operate this website (e.g. to remember your language choice). Optional cookies (e.g. for analytics) are only set with your consent. More information in our',
      privacyLink: 'privacy policy',
      accept: 'Accept all',
      necessary: 'Necessary only',
    },
    whatsapp: {
      tooltip: 'Start chat',
      status: 'Usually replies within 24h',
      greeting: 'Hi 👋 — message us directly via WhatsApp. Pick a topic, or write your own message.',
      choose: 'Quick select',
      preset1: 'Request talent',
      preset2: 'Projects / Subcontractors',
      preset3: 'Application',
      openChat: 'Open WhatsApp chat',
      fallback: 'Hello De Melo Recruiting, I have an inquiry.',
    },
    call: {
      tooltip: 'Call now',
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return 'de';
    return localStorage.getItem('lang') || 'de';
  });
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('lang', lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);
  const t = translations[lang] || translations.de;
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used inside I18nProvider');
  return ctx;
}
